<template>
    <div>
        <PotentiallyInterestedSearch
            ref="search"
            :sale-offer-id="saleOfferId"
            :order-id="orderId"
            :showSearch=false
            v-on:search-start="searchStart"
            v-on:search-complete="searchComplete"
        />
        <PotentiallyInterestedResult
            :sale-offer-id="saleOfferId"
            :wmFinancingSaleOfferId="wmFinancingSaleOfferId"
            :order-id="orderId"
            :companies-prop="companies"
            v-on:sent="$emit('sent')"
        />
    </div>
</template>

<script>
    import PotentiallyInterestedSearch from './PotentiallyInterestedSearch';
    import PotentiallyInterestedResult from './PotentiallyInterestedResult';

    export default {
        components: {PotentiallyInterestedSearch, PotentiallyInterestedResult},
        props: ['saleOfferId', 'orderId', 'wmFinancingSaleOfferId'],
        data() {
            return {
                companies: null,
            }
        },
        methods: {
            searchStart() {
                this.companies = null;
            },
            searchComplete(companies) {
                this.companies = companies;
              this.companies.map((company) => {
                company.selectedEmail = null;
              });
            }
        }
    }
</script>

<style scoped>

</style>